module.exports = __webpack_public_path__ + "img/header-weddingRingsStackingRings.34d16a8.webp";